import React, { Component } from "react";
import SelectFieldThrottled from "../SelectFieldThrottled";
import { recdonOneLiner } from "../../../utils";

export default class SelectDonatingEvent extends Component {
  render() {
    return (
      <SelectFieldThrottled
        field="donating-event"
        {...this.props}
        labelMaker={recdonOneLiner}
      />
    );
  }
}
